export default __webpack_public_path__ + "static/media/images/p2.85ef38f5.jpg";